import React, { useEffect, useState } from "react";
import Tabs from "../UI/tabs";
import ComponentFactory from "./ComponentFactory";
import ButtonSpacer from "../UI/ButtonSpacer";

function UITabs({ tabs, game, editUI, layout }) {
  const [selectedTab, setSelectedTab] = useState();

  useEffect(() => {
    setSelectedTab(tabs?.[0]);
  }, []);

  return (
    <>
      <div className="w-full">
        <Tabs
          tabs={tabs?.map((tab, index) => {
            return {
              default: index === 0,
              name: tab?.data?.label,
              id: index,
              onTabSelected: () => {
                setSelectedTab(tab);
              },
              onTabDeleted: () => {},
            };
          })}
        />
      </div>
      {selectedTab?.children?.map((item) => {
        return (
          <ComponentFactory component={item} game={game} layout={layout} />
        );
      })}
      {editUI && <ButtonSpacer node={selectedTab} />}
    </>
  );
}

export default UITabs;
